<template>
    <div>
        <nav class="menu">
            <div class="liste-lien-menu">
                <div class="titre-menu">
                    <router-link to="/" class="lien-menu cursor">Domaine</router-link>
                </div>
                <div class="titre-menu" v-if="histoire.length > 0">
                    <router-link to="/histoire" class="lien-menu cursor">Histoire</router-link>
                </div>
                <div class="titre-menu">
                    <router-link to="/vins" class="lien-menu cursor">Vins</router-link>
                </div>
                <div class="titre-menu">
                    <a href="https://eco-musee.domainethibaut.fr" target="_blanck" class="lien-menu cursor">Éco-musée</a>
                </div>
                <div class="titre-menu">
                    <router-link to="/actualites" class="lien-menu cursor">Actualités</router-link>
                </div>
                <div class="titre-menu">
                    <router-link to="/contact" class="lien-menu cursor">Contact</router-link>
                </div>
            </div>

            
            <div class="liste-images-labels labels-ordi">
                <img v-for="label in monDomaine.labels" class="image-label cursor" @click="modalLabel = ! modalLabel, labelAggrandi = label.full_image_url" :src="label.full_image_url" alt="">
            </div>

            <div class="bouton-menu-tel div-petit-svg">

            </div>

            <div class="bouton-menu-tel div-petit-svg">
                <svg xmlns="http://www.w3.org/2000/svg" class="svg-bouton-menu-tel" viewBox="0 0 448 512" @click="openMenu = true">
                    <path d="M0 96C0 78.3 14.3 64 32 64H416c17.7 0 32 14.3 32 32s-14.3 32-32 32H32C14.3 128 0 113.7 0 96zM0 256c0-17.7 14.3-32 32-32H416c17.7 0 32 14.3 32 32s-14.3 32-32 32H32c-17.7 0-32-14.3-32-32zM448 416c0 17.7-14.3 32-32 32H32c-17.7 0-32-14.3-32-32s14.3-32 32-32H416c17.7 0 32 14.3 32 32z"/>
                </svg>
            </div>

            <section class="menu-telephone" v-show="openMenu">
                <div class="liste-lien-menu-tel">
                    <div class="titre-menu" @click="openMenu = false">
                        <router-link to="/" class="lien-menu cursor">Domaine</router-link>
                    </div>
                    <div class="titre-menu" @click="openMenu = false" v-if="histoire.length > 0">
                        <router-link to="/histoire" class="lien-menu cursor">Histoire</router-link>
                    </div>
                    <div class="titre-menu" @click="openMenu = false">
                        <router-link to="/vins" class="lien-menu cursor">Vins</router-link>
                    </div>
                    <div class="titre-menu" @click="openMenu = false">
                        <router-link to="/actualites" class="lien-menu cursor">Actualités</router-link>
                    </div>
                    <div class="titre-menu" @click="openMenu = false">
                        <a href="https://eco-musee.domainethibaut.fr" target="_blanck" class="lien-menu cursor">Éco-musée</a>
                    </div>
                    <div class="titre-menu" @click="openMenu = false">
                        <router-link to="/contact" class="lien-menu cursor">Contact</router-link>
                    </div>
                    <div class="titre-menu" @click="openMenu = false">
                        <router-link class="c-gris-blanc lien-menu" to="/mentions-legales">Mentions légales</router-link>
                    </div>
                    <div class="titre-menu" @click="openMenu = false">
                        <router-link class="c-gris-blanc lien-menu" to="/politique-confidentialite">Confidentialité</router-link>
                    </div>
                </div>
                <div class="div-petit-svg svg-fermeture cursor" @click="openMenu = false">
                    <svg xmlns="http://www.w3.org/2000/svg" class="fill-gris-clair-cinquante " viewBox="0 0 384 512">
                        <path d="M342.6 150.6c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0L192 210.7 86.6 105.4c-12.5-12.5-32.8-12.5-45.3 0s-12.5 32.8 0 45.3L146.7 256 41.4 361.4c-12.5 12.5-12.5 32.8 0 45.3s32.8 12.5 45.3 0L192 301.3 297.4 406.6c12.5 12.5 32.8 12.5 45.3 0s12.5-32.8 0-45.3L237.3 256 342.6 150.6z"/>
                    </svg>
                </div>

                <footer class="footer-tel">
                    <p class="c-gris-blanc">L'abus d'alcool est dangereux pour la santé</p>
                    <div class="liste-images-labels labels-tel">
                        <img v-for="label in monDomaine.labels" class="image-label cursor" @click="modalLabel = ! modalLabel, labelAggrandi = label.full_image_url" :src="label.full_image_url" alt="">
                    </div>
                </footer>
            </section>
        </nav>

        <router-view :key="$route.params.id"/>

        <footer class="footer bg-vigne">
            <p class="c-gris-blanc">L'abus d'alcool est dangereux pour la santé</p>
            <span class="c-gris-blanc">|</span>
            <router-link class="c-gris-blanc" to="/mentions-legales">Mentions légales</router-link>
            <span class="c-gris-blanc">|</span>
            <router-link class="c-gris-blanc" to="/politique-confidentialite">Politique de confidentialité</router-link>
        </footer>

        <div class="bg-light modalCookie" v-show="modalCookie">
            <h6 style="font-weight: 700;">Ce site utilise des cookies</h6>
            <p>Afin d'analyser l'audience de ce site internet, l'utilisation de google Analytics à été mis en place.</p>
            <i class="c-gris-fonce">Découvrir l'<a href="" class="c-gris-fonce">utilisation des cookies</a></i>
            <div class="checkbox-ligne">
                    <input type="checkbox" style="width: 15px; height: 15px;" v-model="memoryConsentC" id="memoryConsentC">
                    <label for="memoryConsentC" style="font-size: 12px;">Enregistrer mon choix</label>
                </div>
            <div class="group-btn-fusion" style="margin-top: 10px;">
                <button class="bg-rouge btn-primaire c-gris-blanc" @click="fctGoogle.allConsentGranted('denied'), modalCookie = false, modalConsenCookieFct(memoryConsentC)">Refuser</button>
                <button class="bg-blanc btn-primaire c-gris-blanc" @click="fctGoogle.allConsentGranted('granted'), modalCookie = false, modalConsenCookieFct(memoryConsentC)">Accepter</button>
            </div>
        </div>
        
        <!-- <div class="modalML" v-show="modalConsent">
            <div class="bodyModal bg-gris-blanc">
                <h3>Site à destination d'un public averti.</h3>
                <p>Le site référence des produits alcoolisés, le public y naviguant reconnait donc être informé du contenu présent sur ce site.</p>
                <p>Le propriétaire du site ne sera en aucun cas retenu responsable de la naviguation des utilisateurs sur son site web.</p>
                <div class="checkbox-ligne">
                    <input type="checkbox" v-model="memoryConsent" id="memoryConsent">
                    <label for="memoryConsent">Enregistrer mon choix</label>
                </div>
                <div class="group-btn">
                    <a href="javascript:history.back()" class="bg-rouge c-gris-blanc">Quitter</a>
                    <div class="bg-blanc cursor" @click="modalConsentFct(memoryConsent)">Continuer</div>
                </div>
            </div>
        </div> -->

        <div class="modalML" v-show="modalConsent">
            <div class="bodyModal bg-gris-blanc">
                <h3>Site à destination d'un public averti.</h3>
                <p>Le site référence des produits alcoolisés, le public y naviguant reconnait donc être informé du contenu présent sur ce site.</p>
                <p>Le propriétaire du site ne sera en aucun cas retenu responsable de la naviguation des utilisateurs sur son site web.</p>
                <div class="checkbox-ligne">
                    <input type="checkbox" v-model="memoryConsent" id="memoryConsent">
                    <label for="memoryConsent" style="font-size: 12px;">Enregistrer mon choix</label>
                </div>
                <div class="group-btn">
                    <a href="javascript:history.back()" class="bg-rouge c-gris-blanc">Quitter</a>
                    <div class="bg-blanc c-gris-blanc cursor" @click="modalConsentFct(memoryConsent)">Continuer</div>
                </div>
            </div>
        </div>

        <div class="modalLabel" v-show="modalLabel">
            <div class="bodyModal bg-gris-blanc">
                <i class="fa-solid fa-xmark cursor btn-fermeture" @click="modalLabel = ! modalLabel, labelAggrandi = ''"></i>
                <img :src="labelAggrandi" class="imgLabelAgrandi" alt="">
            </div>
        </div>
    </div>
</template>

<script>
    import params           from '@/param/param.js'
    import services         from '@/services/appService.js'
    import fctFiltres       from '@/functions/filter.js'
    import fctTris          from '@/functions/tris.js'
    import fctGoogle          from '@/functions/google.js'

    export default {
        name: 'App',
        data(){
            return {
                openMenu: false,
                params,
                fctFiltres,
                fctTris,
                fctGoogle,
                services,
                modalConsent: true,
                memoryConsent: false,
                memoryConsentC: false,
                modalCookie: true,

                histoire: [],
                modalLabel: false,
                labelAggrandi: '',
                monDomaine: {},
            }
        },

        created(){
            if(services.getLocal('consent') === null){
                this.modalConsent = true
            }else{
                this.modalConsent = services.getLocal('consent')
            }

            if(services.getLocal('consentCookie') === null){
                this.modalCookie = true
            }else{
                this.modalCookie = false
            }

            axios.get(params.host+'domaine/v1/listeDomaines')
            .then(response => {
                this.monDomaine = fctFiltres.filterBy(response.data, params.domaineID, 'id')[0]
                
                axios.get(params.host+'histoire/v1/listeDates')
                .then(response => {
                    this.histoire = fctFiltres.filterByListe(response.data, 'domaine', 'frise')
                }).catch(error => {
                    console.log(error)
                })
            }).catch(error => {
                console.log(error)
            })
        },

        watch:{
        
        },

        methods:{
            modalConsentFct(id){
                this.modalConsent = false
                services.setLocal('consent', false)
                services.setLocal('enrConsent', id)
            },

            modalConsenCookieFct(id){
                this.modalCookie = false
                if(id === true){
                    services.setLocal('consentCookie', false)
                }
            }
        }
    }
</script>

<style>
</style>





// WEBPACK FOOTER //
// src/App.vue